import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_PHASERESOLVED_GRAPH } from './url-constants';

type PhaseResolvedGraphEndpointSpecification = ApiEndpointSpecification;
export const PhaseResolvedGraphEndpointSpecification: PhaseResolvedGraphEndpointSpecification = {
    url: DEVICE_PHASERESOLVED_GRAPH,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'PhaseResolvedRequestParams',
    requestBodySchemaName: 'PhaseResolvedRequestBody',
    okResponseSchemaName: 'PhaseResolvedOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2
};

export const invokePhaseResolvedGraphData = Helpers.makeApiRequestFn<
    Types.PhaseResolvedDataRequestParams,
    Types.PhaseResolvedDataRequestBody,
    Types.PhaseResolvedDataOkresponse
>(PhaseResolvedGraphEndpointSpecification);
